<template>
	<div>
		<h2 class="mb-2">INTENTOS DE PAGO</h2>
		<div v-for="payment in payments" :key="payment.id" class="mb-2 pb-1 border-bottom">
			<div class="d-flex" @click="updatePayment(payment)">
				<div class="side-icon">
					<div class="icon-payment-provider" :class="payment.acquirerIcon"></div>
				</div>
				<div class="data">
					<h3>{{ payment.acquirerName }}</h3>
					<p v-if="payment.externalPaymentId">#{{ payment.externalPaymentId }}</p>
					<span class="d-flex ">
						<i class="dot mt-1 mr-1" :class="`dot-${payment.statusClass}`"></i>
						<span>{{ payment.statusText }}</span>
					</span>
				</div>
			</div>
		</div>

		<div class="alert alert-light" v-if="order.payments && order.payments.length == 0">No hay intentos de pago registrados</div>

		<OrderRegisterPayment ref="orderRegisterPayment" :order="order" @update="$emit('update')" />
	</div>
</template>

<script>
import OrderRegisterPayment from './OrderRegisterPayment'

export default {
	name: 'OrderPaymentCard',
	components: { OrderRegisterPayment },
	props: ['order'],
	computed: {
		payments() {
			// sort payments by createdAt
			return this.order.payments.sort((a, b) => {
				return b.createdAt > a.createdAt ? 1 : -1
			})
		},
	},
	methods: {
		updatePayment(payment) {
			this.$refs.orderRegisterPayment.open(payment)
		},
	},
}
</script>
<style scoped>
h2 {
	font-size: 14px;
	color: #424242;
}
.side-icon {
	width: 72px;
	display: flex;
	justify-content: center;
}
.side-icon .icon {
	font-size: 18px;
	color: #666;
}
.data {
	flex-grow: 1;
}
h3 {
	font-size: 16px;
}
p {
	line-height: 16px;
	margin: 0px;
}
</style>
